<div class="card h-table-custom">
  @if(showCardHeader){
  <div class="card-header border-0 pt-3 px-6 min-h-auto">
    <ng-content select="[table-header]"></ng-content>
  </div>
  }

  <div class="card-body px-6 py-3 pb-5 mh-table-custom d-flex flex-column justify-content-between" [ngClass]="{
      'pt-6': !showCardHeader,
      'pe-3': vertical_scrollbar,
      'pe-6': !vertical_scrollbar
    }">
    <div id="widget-table" class="table-responsive h-table-body">
      @if(loading){
      <div class="col-12 loading-fixed position-sticky top-0">
        <app-progress-loading [isLoading]="loading"></app-progress-loading>
      </div>
      }
      <table class="table align-middle gs-0 gy-4 mb-0">
        <thead id="table_header">
          <tr class="fw-bolder text-gray-600 bg-gray-200 position-sticky"></tr>
        </thead>
        <tbody>
          @if(sources.data.length){ @for (row of sources.data; track row.id; let
          row_index = $index) {
          <tr [ngClass]="{
              'bg-hover-gray-200': showHoverBg,
              'cursor-pointer': rowClick
            }" (click)="clickedRow(row)" [id]="'row_' + (row_index + 1)">
            <td class="rounded px-4">
              <div class="d-flex flex-column flex-sm-row">
                <div class="me-sm-5">
                  <img [src]="
                      row.image_url
                        ? fileUrl + row.image_url
                        : './assets/media/svg/files/blank-image.svg'
                    "
                    class="object-fit-cover rounded h-150px h-sm-175px h-lg-175px w-100 w-sm-200px mb-4 mb-sm-0" />
                </div>
                <!-- ------------------------------------------------- -->
                <div class="d-flex flex-column flex-md-row flex-md-wrap w-100 my-lg-0">
                  <div
                    class="flex-grow-1 my-lg-0 me-4 h-100 d-flex col-12 col-lg-8 flex-column justify-content-between">
                    <section class="col-lg-10">
                      <a class="text-gray-800 fw-bolder text-hover-primary fs-3">
                        {{ row.name }} </a>
                      <!-- The "เฉพาะคอร์สที่ทดลองเรียนได้" filter narrows THIS
                           list, so this is where the marker has to be. -->
                      @if (row.has_trial_videos) {
                      <span class="badge badge-light-success ms-2 align-middle" data-testid="trial-badge">{{
                        "APP.TRIAL_BADGE" | translate }}</span>
                      }
                      <span class="text-muted pt-1 fs-4 text-overflow-line-3 mb-2">{{ row.description }}</span>
                    </section>
                    <section>
                      <div #tutor class="col-12 pt-lg-6">
                        <div class="d-flex align-items-center flex-wrap gap-2 gap-sm-4 gap-md-8">
                          <div class="d-flex align-items-center min-w-lg-125px">
                            <div class="symbol symbol-circle symbol-30px me-4">
                              @if (row.tutor?.image_url) {
                              <img [src]="`${fileUrl}${row.tutor.image_url}`" class="object-fit-cover" />
                              } @else {
                              <span class="symbol-label bg-light-primary text-primary">
                                <app-keenicon name="user" class="fs-3 text-primary"></app-keenicon>
                              </span>
                              }
                            </div>

                            <a class="text-gray-800 fw-bolder fs-6 me-2">
                              {{ row.tutor?.name || "-" }}
                            </a>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <app-keenicon name="note" class="fs-2"></app-keenicon>
                            <span class="text-gray-500 d-block fs-6">{{ row.total_chapter || 0 }} บทเรียน</span>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <app-keenicon name="time" class="fs-2"></app-keenicon>
                            <span class="text-gray-500 d-block fs-6">{{
                              row.duration_video | durationVideo
                              }}</span>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <app-keenicon name="bookmark" class="fs-2"></app-keenicon>
                            <span class="text-gray-500 d-block fs-6">{{
                              row.education_name
                              }}</span>
                          </div>
                        </div>
                      </div>
                      <section class="d-lg-none mt-4 d-flex align-items-center justify-content-between gap-3">
                        <app-rating-star [rating]="row.rating || 0"></app-rating-star>
                        <div class="course-row__price d-flex align-items-baseline text-nowrap">
                          <!-- A free course showed as "฿0.00", which reads as a pricing bug
                             rather than as free — the landing card, the course page
                             and the cart all say "เรียนฟรี". -->
                          @if (pricing(row).price > 0) {
                          <span class="course-row__now fw-bolder" [class.is-cut]="pricing(row).hasDiscount">{{ pricing(row).price
                            | currency: "฿" }}</span>
                          } @else {
                          <span class="course-row__now fw-bolder is-free">{{ "APP.FREE" | translate }}</span>
                          }
                          @if (pricing(row).hasDiscount) {
                          <span class="course-row__was text-decoration-line-through">{{ pricing(row).originalPrice | currency: "฿" }}</span>
                          }
                        </div>
                      </section>
                    </section>
                  </div>
                  <!-- ------------------------------------------------------------- -->
                  <!-- Price belongs in the list, not only on the detail page:
                       a catalogue you cannot compare prices in sends people
                       into eight tabs to find out what anything costs. -->
                  <section class="d-none d-lg-flex flex-column align-items-end gap-2">
                    <app-rating-star [rating]="row.rating || 0"></app-rating-star>
                    <div class="course-row__price d-flex align-items-baseline text-nowrap">
                      <!-- A free course showed as "฿0.00", which reads as a pricing bug
                             rather than as free — the landing card, the course page
                             and the cart all say "เรียนฟรี". -->
                      @if (pricing(row).price > 0) {
                      <span class="course-row__now fw-bolder" [class.is-cut]="pricing(row).hasDiscount">{{ pricing(row).price |
                        currency: "฿" }}</span>
                      } @else {
                      <span class="course-row__now fw-bolder is-free">{{ "APP.FREE" | translate }}</span>
                      }
                      @if (pricing(row).hasDiscount) {
                      <span class="course-row__was text-decoration-line-through">{{ pricing(row).originalPrice | currency: "฿" }}</span>
                      }
                    </div>
                  </section>
                </div>
                <!-- ------------------------------------------------------ -->
              </div>
            </td>
          </tr>
          @if(row_index != sources.data.length -1){

          <div class="separator my-4"></div>
          } } }@else{
          <tr class="text-center">
            <td [colSpan]="dataColumns.length">
              <ng-container *ngTemplateOutlet="noData"></ng-container>
            </td>
          </tr>

          }
        </tbody>
      </table>
    </div>
    @if(sources.data.length){
    <div class="pagination-fixed position-sticky bottom-0 bg-white px-4">
      <app-paginations [dataSource]="sources" [isLoading]="loading"
        (onPageChange)="onTableChange($event)"></app-paginations>
    </div>
    }
  </div>
</div>

<ng-template #noData>
  <div class="d-flex justify-content-center align-items-center h-inherit text-gray-600 fw-normal fs-6 pt-2">
    {{ "TABLE.NO_DATA_DISPLAY" | translate }}
  </div>
</ng-template>